const FILTER_SLOTS = 4

function getStep({maxPrice, minPrice}) {
  const roundedUp = Math.ceil((maxPrice - minPrice) / FILTER_SLOTS)

  return roundedUp + (100 - (roundedUp % 100))
}

function createRanges({step, maxPrice, minPrice, productPrices}) {
  const result = []
  let slotMin = Math.ceil(minPrice)
  let slotMax = slotMin + step
  // Agrega el 1er SLOT. Contendrá precios de 0 al primer 1/4 del valor total
  result.push({
    label: `Menos de ${slotMax}`,
    range: {min: 0, max: slotMax},
    value: false,
    quantity: quantityValue(productPrices, 0, slotMax)
  })
  // Agrega N-2 SLOTS
  for (let i = 1; i < FILTER_SLOTS - 1; i++) {
    // El inicio de este SLOT es el final del anterior
    slotMin = slotMax
    slotMax = slotMin + step
    result.push({
      label: `${slotMin} - ${slotMax}`,
      range: {min: slotMin, max: slotMax},
      value: false,
      quantity: quantityValue(productPrices, slotMin, slotMax)
    })
  }
  const lastSlotMin = slotMax
  // Agrega último SLOT. Contendrá precios desde el último 1/4 en adelante.
  result.push({
    label: `Más de ${lastSlotMin}`,
    range: {min: lastSlotMin, max: maxPrice},
    value: false,
    quantity: quantityValue(productPrices, lastSlotMin, maxPrice)
  })
  return result
}

function quantityValue (productPrices, minAmount, maxAmount) {
  const quantity = productPrices.filter(
    productPrice => productPrice >= minAmount && productPrice <= maxAmount
  ).length
  return quantity
}

export default function generatePriceFilters(productPrices) {
  const maxPrice = Math.max(...productPrices)
  const minPrice = Math.min(...productPrices)

  const step = getStep({maxPrice, minPrice})

  return createRanges({step, maxPrice, minPrice, productPrices})
}
